// extracted by mini-css-extract-plugin
export var cardIcon = "_bg-5";
export var cardIconUnframed = "_bg-9";
export var checkboxCard = "_bg-0";
export var checkboxCardSelected = "_bg-4";
export var disabled = "_bg-2";
export var interactive = "_bg-1";
export var outerBorder = "_bg-3";
export var spacerMedium = "_bg-8";
export var spacerSmall = "_bg-7";
export var spacerXsmall = "_bg-6";